export const CONSTANTS = {
  SUCCESS: 0,
  TOKEN_INCORRECT: 333,
  TOKEN_EXPIRED: 555,
  TOKEN_NOT_EXIST: 777,
  UNAUTHORIZED: 6699,
  E_CM_01: "E_CM_01",
  E_CM_02: "E_CM_02",
  E_CM_04: "E_CM_04",
  E_CM_06: "E_CM_06",
  E_TC_RQCN: "E_TC_RQCN", //Mã lỗi chức năng test connection. Lỗi connect string required
  E_TC_FSCN: "E_TC_FSCN", //Mã lỗi chức năng test connection. Lỗi không thể mở kết nối
  E_TC_DBNP: "E_TC_DBNP", //Mã lỗi chức năng test connection. Database không tồn tại
  E_TC_DBSF: "E_TC_DBSF", //Mã lỗi chức năng test connection. Database tồn tại nhưng bị inactive
  E_TC_IPNP: "E_TC_IPNP", //Mã lỗi chức năng test connection. IP không tồn tại
  E_TC_UPNP: "E_TC_UPNP", //Mã lỗi chức năng test connection. Username hoặc password sai.
  E_TC_PNP: "E_TC_PNP", //Mã lỗi chức năng test connection. Post không tồn tại.
  E_TC_EX: "E_TC_EX", //Mã lỗi chức năng test connection. Lỗi ngoại lệ.
  S_TC_CNSS: "S_TC_CNSS", //Mã code chức năng test connection. Connection thành công.
};

export function SAFIE_URI(clientId, URI) {
  return `https://openapi.safie.link/v1/auth/authorize?client_id=${clientId}&response_type=code&scope=safie-api&redirect_uri=${URI}`

}

export default SAFIE_URI();
